import { FetcherResponse } from '../../../../../../../../components/Hooks/useList.types';
import { ChatParticipant } from '../../../../../../types/chat.types';
import { sortChatParticipantByName } from '../../../../../../utils/chatParticipants.utils';
import { ChatParticipantsState } from './chatParticipants.types';

export const chatParticipantsInitialState: ChatParticipantsState = {
  isLoading: false,
  error: undefined,
  page: 0,
  participants: [],
  totalItems: 0,
  hasMore: false,
  query: '',
};

export const chatParticipantsReducer = (
  state: ChatParticipantsState,
  action: any,
): ChatParticipantsState => {
  switch (action.type) {
    case 'FETCHING_MORE':
      return {
        ...state,
        isLoading: true,
      };
    case 'FETCH_MORE_RESULT': {
      const response: FetcherResponse<ChatParticipant> = action.payload;
      if (response.tag === 'error') {
        return {
          ...state,
          isLoading: false,
          participants: [],
          error: response.error,
        };
      }

      const newItems = [
        ...state.participants,
        ...response.data.map((chat) => ({ ...chat, wasRemoved: false })),
      ];
      return {
        ...state,
        isLoading: false,
        participants: newItems,
        totalItems: response.count,
        hasMore: newItems.length < response.count,
        page: state.page + 1,
      };
    }

    case 'INSERT_PARTICIPANT': {
      const { participant }: { participant: ChatParticipant } = action.payload;

      const participants = [participant, ...state.participants];
      const sortedParticipants = participants.sort(sortChatParticipantByName);
      return {
        ...state,
        participants: sortedParticipants,
      };
    }
    case 'REMOVE_PARTICIPANT': {
      const { participant } = action.payload;
      return {
        ...state,
        participants: state.participants.filter(({ id }) => participant.id !== id),
      };
    }
    case 'UPDATE_QUERY': {
      return {
        ...chatParticipantsInitialState,
        query: action.payload.query,
      };
    }
    default:
      throw new Error('Ação do reducer não encontrada');
  }
};

export const fetchingMore = () => ({ type: 'FETCHING_MORE' });

export const fetchMoreResult = <T>(payload: FetcherResponse<T>) => ({
  type: 'FETCH_MORE_RESULT',
  payload,
});

export const insertParticipant = (payload: { participant: ChatParticipant }) => ({
  type: 'INSERT_PARTICIPANT',
  payload,
});

export const removeParticipant = (payload: { participant: ChatParticipant }) => ({
  type: 'REMOVE_PARTICIPANT',
  payload,
});

export const updateQuery = (payload: { query: string }) => ({
  type: 'UPDATE_QUERY',
  payload,
});
